import React, { useState } from "react";
import styled from "styled-components";
import { deviceSize } from "../responsive";
import { useMediaQuery } from "react-responsive";
import { icon } from "./data";
import { FaChevronCircleLeft, FaChevronCircleRight } from "react-icons/fa";
import { useSpring, animated } from "react-spring";
import { useDrag } from "react-use-gesture";

// import gradient from "../../images/gradient.png";
import rect from "../../images/mobileImages/Rect.svg";

const ExpedientWayCon = styled.div`
  text-align: center;
  width: 100%;
  display: flex;
  height: 800px;
  margin-top: 10%;

  @media screen and (max-width: ${deviceSize.desktop}px) {
    height: 900px;
  }

  @media screen and (max-width: ${deviceSize.monitor}px) {
    background-position: 0px -200px;
  }

  @media screen and (max-width: ${deviceSize.Slaptop}px) {
    background-position: 0px 0px;
  }

  @media screen and (max-width: ${deviceSize.laptop}px) {
    background-position: 0px 0px;
    height: 700px;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    background: url(${rect}) no-repeat;
    background-size: contain;
    background-position: 0px 100%;
    height: 520px;
    margin-top: 0;
    
  }

  @media screen and (max-width: ${deviceSize.smobile}px) {
    background: url(${rect}) no-repeat;
    background-size: contain;
    background-position: 0px 130px;

  }
`;

const ExpedientWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;

  

`;


const ExpP = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 800;
  font-size: 20px;
  font-variant: small-caps;
  line-height: normal;
  width: 500px;
  height: 9%;
  top: 70px;
  color: #fff;
  left: 60px;
  margin-left: 2%;
  margin-top: 93px;
  margin-bottom: 25px;
  background: #9d2222;

  @media screen and (max-width: ${deviceSize.laptop}px) {
    width: 60%;
    font-size: 1.2rem;
    left: 60px;
  }

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    width: 60%;
    font-size: 20px;
    font-size: 1.2rem;
    left: 60px;
  }

  @media screen and (max-width: ${deviceSize.tablet}px) {
    left: 30px;
    font-size: 28px;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    width: 80%;
    font-size: 16px;
    margin: auto;
    margin-top: 10px;
    height: 100%;
    font-weight: 500;
  }
`;

// const curve = styled.svg`
//   display: block;
// `;

const ExpWayTabContainer = styled.div`
 
 display: flex ;
 flex-direction:row;
 top:0px;
 width:800px;
 left:35%;
 margin-right:20px;
 height: 200px;
 padding-top: 65px;
 height: 50%;



@media screen and (max-width: ${deviceSize.laptop}px){
     
    top: 40px;
    width: 800px;
    height: 50%;
    left: 35%;

 }


 
@media screen and (max-width: ${deviceSize.slaptop}px){
     
    left:15%;

 }


@media screen and (max-width: ${deviceSize.tablet}px){
     
     top:70px;
     left:10%;
     margin-right: 0px;
     width:90%;

 }


@media screen and (max-width: ${deviceSize.mobile}px){
  
  display:none;
  width:90%;
  height:100%;
 }

`;

const ExpWayTabContainerM = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  z-index: 0;
  margin-top: 45px;
  

  
  
  @media screen and (max-width: ${deviceSize.tablet}px) {
  }

`;

const TabContainer3 = styled.div`
  width: 316px;
  height: 402px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
`;

const Chervon = styled.div`
  width: 20%;
  height: 100%;
`;

const TabContainer2 = styled.div`
  display: flex;
  height: 280px;
  flex-direction: column;
  align-items: space-evenly;
  position: relative;
  border-right: 4px solid #ffffff;

  @media screen and (max-width: ${deviceSize.mobile}px) {
  }
`;

const TabText = styled.div`
  width: 400px;
  height: 140px;
  margin-left: 40px;
  position: relative;
  top: 60px;
  line-height: 1.4;
  color: #454444;
  font-weight: 500;
  font-size: 16px;
  text-align: left;
  font-family: "Sunflower", "Helvetica", "arial";
  text-align: left;
  padding: 1px;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    width: 100%;
    margin-left: 0px;
    text-align: center;
    transition: all 200ms ease-in-out;
    color: white;
  }
`;

const ImgWrap = styled.div`
  height: 140px;
  width: 140px;
  margin-left: 60px;
  position: relative;
  top: 30px;

  @media screen and (max-width: ${deviceSize.tablet}px) {
    height: 120px;
    width: 120px;
    margin-left: 30px;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    height: 94px;
    width: 94px;
    margin-left: 0px;
    position: inherit;
  }
`;

const Img = styled.img`
  width: 100%;
  height: 100%;
  margin: 0 0 10px 0;
  padding-right: 0;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    transition: all 200ms ease-in-out;
  }
`;

const Tutton = styled.div`
  outline: none;
  height: 54px;
  width: 54px;
  text-align: right;
  font-family: "Sunflower";
  color: #454444;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  margin-right: 80px;
  transition: all 200ms ease-in-out;
  cursor: pointer;

  &.active {
    color: #9D2222;
    font-size: 31px;
    line-height: 39px;
    font-weight: 400;
  }

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    font-size: 23px;

    &.active {
      color: #000;
      font-size: 27px;
      line-height: 39px;
    }

    @media screen and (max-width: ${deviceSize.tablet}px) {
      font-size: 15px;

      &.active {
        color: #000;
        font-size: 23px;
        line-height: 39px;
      }
    }

    @media screen and (max-width: ${deviceSize.mobile}px) {
      &.active {
        color: #000;
        font-size: 23px;
        line-height: 39px;
      }
    }
  }
`;

const ItemTitle = styled.h5`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 1.5em;
  line-height: 23px;
  width: 40%;
  height: 40px;
  margin-top: 60px;
  text-align: center;
  transition: all 200ms ease-in-out;

  @media screen and (max-width: 768px) {
    margin-top: 5%; 
    margin-bottom: 0;
  }

`;

const ButtonContainer = styled.div`
  margin-top: 100px;
  height: 23px;
  /* width: 23px; */
`;

const ButtonNext = styled.div`
  height: 23px;
  width: 23px;
  margin-right: 18px;
`;

const ButtonPrev = styled.div`
  height: 23px;
  width: 23px;
  margin-left: 44px;
`;

// const styleObject = {
//   height: "100%",
//   width: "100%",
// };

const Slider = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  height: 100%;
  overflow: hidden;
  position: relative;

  @media screen and (max-width: ${deviceSize.mobile}px) {
  }
`;

const SliderItem = styled.div`
  flex-shrink: 0;
  width: 100%;
  display: flex;
  justify-content: center;
`;

const THRESHOLD = 2;

export function ExpedientWay() {
  const [value, setValue] = useState(0);
  const [active, setActive] = useState(0);
  const isMobile = useMediaQuery({ maxWidth: deviceSize.mobile });

  const checkNumber = (number) => {
    if (number > icon.length - 1) {
      return 0;
    }

    if (number < 0) {
      return icon.length - 1;
    }
    return number;
  };

  const nextIcon = () => {
    setValue((value) => {
      let newvalue = value + 1;
      return checkNumber(newvalue);
    });
  };

  const prevIcon = () => {
    setValue((value) => {
      let newvalue = value - 1;
      return checkNumber(newvalue);
    });
  };

  const [animating, setAnimating] = useState(false);
  const [{ x }, set] = useSpring(() => ({
    x: [0, 0],
  }));

  const bind = useDrag(({ movement: [mx] }) => {
    if (animating) {
      return;
    }

    let moveX = (mx / window.innerHeight) * 1000;

    if (moveX < -THRESHOLD) {
      moveX = -1;

      nextIcon();
      animateNextSlide();
    } else if (moveX > THRESHOLD) {
      moveX = 1;
      prevIcon();
      animateNextSlide();
    }

    moveX = moveX - 377 * setValue;

    set({
      x: [moveX, 0],
    });
  });

  const animateNextSlide = () => {
    setAnimating(true);
    setTimeout(() => {
      setAnimating(false);
    }, 500);
  };

  const { text, title, img, imgt } = icon[value];
  return (
    <ExpedientWayCon>
      <ExpedientWrapper id="exp-wrapper">
        <ExpP>EXPERIENCE "THE EXP WAY"</ExpP>

        {!isMobile && (
          <ExpWayTabContainer>
            <TabContainer2>
              {icon.map((item, index) => {
                return (
                  <Tutton
                    key={item.id}
                    className={active === index ? "active" : ""}
                    onClick={() => {
                      setValue(index);
                      setActive(index);
                    }}
                  >
                    {item.title}
                  </Tutton>
                );
              })}
            </TabContainer2>

            <ImgWrap>
              <Img src={img} alt={imgt} />
            </ImgWrap>

            <TabText>{text}</TabText>
          </ExpWayTabContainer>
        )}

        {isMobile && (
          <ExpWayTabContainerM id="expway-container">
            <Slider id="slider" as={animated.div} {...bind()}>
              {icon.map((item, index) => (
                <SliderItem
                  as={animated.div}
                  key={item.id}
                  style={{
                    transform: x.to(
                      (value) => `translate3d(${value}px,0px,0px)`
                    ),
                  }}
                >
                  <Chervon id="chevron">
                    <ButtonContainer>
                      <ButtonPrev onClick={prevIcon}>
                        <FaChevronCircleLeft
                          style={{ height: "100%", width: "100%" }}
                        />
                      </ButtonPrev>
                    </ButtonContainer>
                  </Chervon>
                  <TabContainer3>
                    <ImgWrap>
                      <Img src={img} alt={imgt} />
                    </ImgWrap>
                    <ItemTitle >{title}</ItemTitle>
                    <TabText>{text}</TabText>
                  </TabContainer3>
                  <Chervon>
                    <ButtonContainer>
                      <ButtonNext onClick={nextIcon}>
                        <FaChevronCircleRight
                          style={{ height: "100%", width: "100%" }}
                        />
                      </ButtonNext>
                    </ButtonContainer>
                  </Chervon>
                </SliderItem>
              ))}
            </Slider>
          </ExpWayTabContainerM>
        )}
      </ExpedientWrapper>
    </ExpedientWayCon>
  );
}
